import React, { useMemo } from "react";
import { Link } from "react-router-dom";

export default function CheckoutCancelledPage() {
  const registrationSlug = useMemo(
    () => sessionStorage.getItem("pendingRegistrationEventSlug"),
    [],
  );

  return (
    <div className="eh-page mx-auto py-12 mb-24 max-w-[560px]">
      <div className="eh-card shadow-sm text-center">
        <p className="text-xs font-semibold uppercase tracking-wide text-slate-500 mb-2">
          Payment cancelled
        </p>
        <h1 className="text-2xl font-bold text-slate-900 mb-3">
          Checkout cancelled
        </h1>
        <p className="text-sm text-slate-600 leading-relaxed mb-2">
          You cancelled the payment before it was completed. No charge has been
          made.
        </p>
        <p className="text-sm text-slate-600 leading-relaxed mb-8">
          Your registration details are still saved. You can return to review
          and pay when you are ready.
        </p>

        <div className="flex flex-col sm:flex-row gap-3 justify-center">
          {registrationSlug ? (
            <Link
              to={`/events/${registrationSlug}/register?resume=1`}
              className="eh-btn-primary px-5 py-2.5 text-sm font-medium"
            >
              Back to registration
            </Link>
          ) : null}
          <Link
            to="/"
            className="eh-btn-secondary px-5 py-2.5 text-sm font-medium"
          >
            Continue browsing
          </Link>
        </div>
      </div>
    </div>
  );
}
